import React from 'react';
import { mockData } from '../mockData';
import { FileCheck, CheckCircle, Award } from 'lucide-react';

const ProcessSection = () => {
  const icons = [FileCheck, CheckCircle, Award];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Simple 3-Step{' '}
            <span className="bg-brand-gradient bg-clip-text text-transparent">
              Registration Process
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            At Trademark Law Associates, we make trademark registration easy. Here's how it works:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {mockData.processSteps.map((step, index) => {
            const Icon = icons[index];
            return (
              <div
                key={step.id}
                className="relative group"
              >
                <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl p-8 h-full hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                  <div className="flex items-center justify-between mb-4">
                    <div className="bg-brand-gradient text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl">
                      {step.id}
                    </div>
                    <div className="bg-white p-3 rounded-full shadow-md group-hover:scale-110 transition-transform">
                      <Icon className="text-brand-primary" size={24} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </div>
                {index < mockData.processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <div className="w-8 h-0.5 bg-gradient-to-r from-emerald-400 to-teal-400"></div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
